
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-optout-instructions/discord",
      function () {
        return require("private-next-pages/ai-optout-instructions/discord/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-optout-instructions/discord"])
      });
    }
  